import styled from 'styled-components';
import { theme } from '../../theme';
export const StyledButton = styled.button.withConfig({ displayName: "vui--StyledButton", componentId: "vui--x718nd" }) `user-select:none;box-sizing:border-box;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;font-family:${theme.fontFamily};font-weight:400;border:1px solid;box-shadow:0 1px 3px rgba(55, 66, 77, 0.15);${({ size, checked }) => {
    let height = '40px';
    let paddingLeft = '24px';
    let paddingRight = '24px';
    let borderRadius = '8px';
    let fontSize = '16px';
    let outlineWidth = '4px';
    let backgroundColor = 'white';
    let borderColor = '#CDD1D5';
    let color = '#37424D';
    if (size === 'sm') {
        height = '32px';
        paddingLeft = '16px';
        paddingRight = '16px';
        borderRadius = '4px';
        fontSize = '14px';
        outlineWidth = '2px';
    }
    if (checked) {
        backgroundColor = '#0079D1';
        borderColor = '#0079D1';
        color = 'white';
    }
    return `
      --outline-width: ${outlineWidth};

      height: ${height};
      padding-left: ${paddingLeft};
      padding-right: ${paddingRight};
      border-radius: ${borderRadius};
      font-size: ${fontSize};

      background-color: ${backgroundColor};
      border-color: ${borderColor};
      color: ${color};
    `;
}} & > * + *{margin-left:8px;}&:hover{cursor:pointer;background-color:${({ checked }) => (checked ? '#005A9C' : '#FAFAFB')};}&:active{background-color:${({ checked }) => (checked ? '#005A9C' : '#FAFAFB')};border-color:${({ checked }) => (checked ? '#005A9C' : '#0079D1')};box-shadow:0 0 0 var(--outline-width)#80bce8;}&:focus{box-shadow:0 0 0 var(--outline-width)#80bce8;outline:0;}&:disabled{cursor:unset;box-shadow:none;background-color:#dfe3e8;border-color:#dfe3e8;color:#637381;}& > span{position:relative;top:-1px;}`;
//# sourceMappingURL=styled.js.map